import Country from "./Country";
import Municipality from "./Municipality";
import Province from "./Province";

class SearchCriteria {
  public last_update: number;

  constructor(
    public search: string,
    public alteration_id?: number[],
    public material_id?: number[],
    public types?: string[],
    public scale?: string[],
    public category?: string[],
    public conservation?: string[],
    public country_id?: number,
    public province_id?: number,
    public municipality_id?: number,
    public year_from?: number,
    public year_to?: number,

    // pagination
    public page?: number,
    public per_page?: number,
    public sort?: string,
    public order?: string,

    // local information -> not sent in the query
    public local_country?: Country,
    public local_province?: Province,
    public local_municipality?: Municipality
  ) {
    this.alteration_id = [];
    this.material_id = [];
    this.types = [];
    this.page = 1;
    this.per_page = 20;
    this.sort = "created_on";
    this.order = "desc";
    this.last_update = new Date().getTime();
  }

  public static EmptyInstance(): SearchCriteria {
    return new SearchCriteria("");
  }
}

export default SearchCriteria;
